import React, { Component } from 'react';
import styled from 'styled-components';
import ReactCustomFlagSelect from 'react-custom-flag-select';
import { PrestoAppTheme } from 'presto-mini-apps-lib';

import { phrase_DefaultError } from '../../constants/text';
import { getOSUserAgent, OSType } from '../../constants/appState'; 
import { Flags } from '../../assets/images'
import { appService } from '../../services';
import ErrorMessage from '../ErrorMessage/index';

import "react-custom-flag-select/lib/react-custom-flag-select.min.css";


class TextInputWithLabel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            countryCodeList: [],
            otpResendInSecond: 0,
            otpText: 'Get OTP',
            otpSent: false,
        };

        this.otpTimer = null;
        this.inputRef = React.createRef();
        this.changeHandler = this.changeHandler.bind(this);
    }

    componentDidMount() {
        const { hasCountrySelector } = this.props;
        if(!!hasCountrySelector) {
            appService.apiGetCountryCode({
                onSuccess: (data) => {
                    const tempArr = [];
                    data.map(item => {
                        const tempObj = { 
                            id: item.mobileCountryCode, 
                            name: item.code, 
                            displayText: item.mobileCountryCode + ' ' + item.countryName, 
                            locale: 'en-US', 
                            flag: item.imageUrl
                        };
                        tempArr.push(tempObj);
                    });
    
                    this.setState({ countryCodeList: tempArr });
                },
                onError: (error) => {
                    console.log('Error getting Country Code:', error);
                }
            })
        }
    }

    componentDidUpdate(prevProps) {
        const { 
            clearField,
            isError,
            defaultVal,
            withOtp,
        } = this.props;
        
        if(prevProps.isError !== isError) {
            if(isError) {
                this.clearVal();
            }
        }

        if(prevProps.clearField !== clearField) {
            if(clearField) {
                this.clearVal();
                if (!!defaultVal) {
                    this.inputRef.current.value = defaultVal;
                }
            }
        }

        if(prevProps.withOtp !== withOtp) {
            clearInterval(this.otpTimer);
            this.setState({
                otpResendInSecond: 0,
                otpText: 'Get OTP',
                otpSent: false,
            });
        }
    }

    componentWillUnmount() {
        this.clearVal();
        clearInterval(this.otpTimer);
    }

    clearVal = () => {
        this.inputRef.current.value = '';
    }

    getHiddenInputValue = () => {
        if(!this.inputRef || !this.inputRef.current ) {
            return '';
        }
        const val = this.inputRef.current.value;
        return val;
    }

    changeHandler = (e) => {
        e.preventDefault();

        const { type, maxLength } = this.props;
        const inputType = (type === 'number-password' ? 'number' : type);

        if(!!maxLength && inputType === 'number') {
            const val = this.inputRef.current.value;
            if(val.length > maxLength) {
                this.inputRef.current.value = val.slice(0, maxLength);
            }
        }

        const { inputStateChangeHandler } = this.props;
        inputStateChangeHandler(e.currentTarget.value, e.currentTarget.name);
    };

    onEnterTrigger = (e) => {
        if (e.keyCode === 13) {
            const { enterTrigger } = this.props;
            enterTrigger(e);
        }
    };

    otpClickHandler = (e) => {
        const { enableOtp, requestOtpHandler } = this.props;
        if (this.state.otpSent || !enableOtp) {
            console.log('otp disabled');
            return;
        }

        clearInterval(this.otpTimer);
        if (requestOtpHandler) {
            requestOtpHandler((resp) => {
                if (!!resp.success) {
                    const resendOtpPeriod = resp.data.resendOtpPeriod;
                    this.setState({
                        otpResendInSecond: resendOtpPeriod,
                        otpText: 'Resend OTP (' + resendOtpPeriod + ')',
                        otpSent: true
                    });

                    this.otpTimer = setInterval(() => {
                        const { otpResendInSecond } = this.state;
                        const resend = otpResendInSecond - 1;
                        if (resend > 0) {
                            this.setState({
                                otpResendInSecond: resend,
                                otpText: 'Resend OTP (' + resend + ')'
                            });
                        } else {
                            this.setState({
                                otpResendInSecond: 0,
                                otpText: 'Resend OTP',
                                otpSent: false
                            });
                            clearInterval(this.otpTimer);
                        }
                    }, 1000);
                } else {
                    // Failed
                    console.log(resp);
                }
            })
        }
    }

    render() {
        const {
            label,
            inputName,
            type = 'text',
            value,
            placeholderText,
            preText,
            hasCountrySelector,
            countrySelectorDefaultCode,
            countrySelectorOnChange,
            isError,
            errorMessage = phrase_DefaultError,
            maxLength,
            disabled,
            enterTrigger,
            inputStyle,
            withOtp,
            enableOtp
        } = this.props;

        const { countryCodeList, otpText, otpSent } = this.state;

        const maxNum = +(Array( (maxLength || 0) +1).join('9'));
        const inputType = (type === 'number-password' ? 'number' : type);

        return (
            <TextInputWrapper className="text-input-component">
                { (!!label && label !== '') && 
                    <div className="label">{label}</div> 
                }
                <div className={[
                    (inputStyle !== undefined ? inputStyle : 'input'),
                    (type === 'number-password' ? ' is-password' : ''),
                    (!!hasCountrySelector && hasCountrySelector !== '' ? ' has-country-selector' : ''),
                    (!!disabled ? ' disabled' : '')
                ].join('')}>
                    { (!!preText && preText !== '') && 
                        <div className="pre-text">{preText}</div> 
                    }
                    { (!!hasCountrySelector && hasCountrySelector !== '' && countryCodeList.length > 0) && (
                        <div className="pre-text"> 
                            <ReactCustomFlagSelect
                                id={'countryCode'} 
                                name={'countryCode'} 
                                value={countrySelectorDefaultCode} 
                                optionList={countryCodeList} 
                                showSearch={true}
                                classNameWrapper="country-code-selector" 
                                customStyleContainer={{ position: 'static' }} 
                                customStyleSelect={{ width: '100%' }} 
                                customStyleOptionListContainer={{ 
                                    maxHeight: '130px',
                                    overflow: 'auto', 
                                    width: '100%'
                                }} 
                                onChange={countrySelectorOnChange}
                            />
                        </div> 
                    )}
                    <div className="text-input">
                        { type === 'number-password' && (
                            <input 
                                className='password-display'
                                type='password' 
                                value={this.getHiddenInputValue()}
                                placeholder={!!disabled ? '' : placeholderText} 
                                disabled={!!disabled}
                                readOnly
                            />
                        )}
                        <input 
                            ref={this.inputRef} 
                            id={inputName} 
                            name={inputName} 
                            type={inputType} 
                            className={ type === 'number-password' ? 'masked-display' : '' }
                            placeholder={!!disabled ? '' : placeholderText} 
                            { ...(!!maxLength ? {maxLength} : {}) }
                            { ...(inputType === 'number' ? { 
                                min: 0, 
                                max: maxNum,
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                                onKeyDown: (e) => {
                                    if(['e', '.', '+', '-'].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                },
                                ...(!!maxLength ? {
                                    onKeyPress: (e) => {
                                        const elm = e.target;
                                        if(elm.value.length === +maxLength) {
                                            e.preventDefault();
                                        }
                                    }
                                } : {}),
                                tabIndex: 0
                            } : {}) }
                            { ...(enterTrigger !== undefined ? {
                                onKeyDown: (e) => {
                                    this.onEnterTrigger(e);
                                }
                            } : {}) }
                            onChange={ this.changeHandler }
                            value={value}
                            disabled={!!disabled}
                        />
                    </div>
                    {withOtp && (
                        <a disabled={otpSent || !enableOtp} className={otpSent || !enableOtp ? 'get-otp disabled' : 'get-otp'} onClick={this.otpClickHandler}>{otpText}</a>
                    )}
                </div>
                { !!isError && <ErrorMessage message={errorMessage} /> }
            </TextInputWrapper>
        );
    }
}

export default TextInputWithLabel;


const TextInputWrapper = styled.div`
    margin-bottom: ${PrestoAppTheme.layout.smallGap};
    
    & > .label { 
        font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
        font-weight: 400;
        text-transform: uppercase;
    }

    & > .input { 
        display: flex;
        font-size: ${PrestoAppTheme.layout.fontSizeStandard};
        border-bottom: 1px solid ${PrestoAppTheme.colors.baseGreyDark};

        &.disabled {
            border-bottom: 1px solid ${PrestoAppTheme.colors.baseSnow};
        }

        &.has-country-selector {
            position: relative;
        }

        & .pre-text, 
        & .text-input, 
        & .text-input > input { 
            height: 2.1rem;
            line-height: 2.1rem;
            font-weight: 300;
            background-color: transparent;
        }

        & input[type=number] {
            -moz-appearance:textfield;
        }

        & a {

            &.get-otp {
                font-weight: 400;
                font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
                color: ${PrestoAppTheme.colors.baseBlue};
                cursor: pointer;
                position: absolute;
                right: 0;
                margin-top: 10px;
            }

            &.disabled {
                color: ${PrestoAppTheme.colors.baseGrey};
            }
        }

        & .pre-text {
            width: 5.7rem;
            margin-right: ${PrestoAppTheme.layout.smallGap};

            & .country-code-selector {
                position: static;

                & [class^="react-custom-flag-select__select__selector"] {
                    padding: 0;

                    & [class^="react-custom-flag-select__select__dropdown-flag"] {
                        flex: 0 0 40%;
                    }

                    & [class^="react-custom-flag-select__select__dropdown-name"] {
                        flex: 0 0 55%;
                        justify-content: inherit;

                        & [class^="react-custom-flag-select__select__dropdown-icon"]:before {
                            width: 6px;
                            height: 6px;
                            top: 3px;
                            right: 3px;
                            border: 0;
                            border-right: 2px solid #999;
                            border-top: 2px solid #999;
                            transform: rotate(135deg);
                        }
                    }
                }

                & [class^="react-custom-flag-select__select__options-container"] {
                    width: 100%;
                    border: 1px solid ${PrestoAppTheme.colors.baseGrey};
                    box-shadow: 0 0 0;
                    box-sizing: border-box;
                    border-radius: ${PrestoAppTheme.layout.borderRadius};
                    font-size: ${PrestoAppTheme.layout.fontSizeSmall};
                    overflow: hidden;

                    & [class^="react-custom-flag-select__select__searchInputWrapper"] {
                        padding: 0;
                        border-bottom: 1px solid ${PrestoAppTheme.colors.baseGrey};
                        height: 2rem;

                        & [class^="react-custom-flag-select__select__searchInputSearchIcon"] {
                            display: none;
                        }

                        & [class^="react-custom-flag-select__select__searchInput"] {
                            height: 100%;
                            border: 0;
                            padding: 0 ${PrestoAppTheme.layout.smallGap};

                            &:focus {
                                outline: none;
                            }
                        } 
                    }

                    & [class^="react-custom-flag-select__select__options-item"] {
                        display: flex;
                        justify-content: space-between;
                        line-height: 1.2rem;
                        padding: ${PrestoAppTheme.layout.xSmallGap} ${PrestoAppTheme.layout.commonGap};

                        & [class^="react-custom-flag-select__select__dropdown-flag"] {
                            flex: inherit;
                            width: 1.5rem;
                        }
                        
                        & [class^="react-custom-flag-select__select__dropdown-name"] {
                            flex: inherit;
                            width: calc(100% - 1.5rem - ${PrestoAppTheme.layout.smallGap});
                            text-align: left;
                            justify-content: normal;
                        }
                    }

                    & [class*="react-custom-flag-select__select__hover-active"] {
                        background-color: #e1e1e1;
                        color: #4a4a4a;
                    }
                }
            }
        }

        & .text-input { 
            width: 100%;
        }
        
        & .text-input > input { 
            border: 0;
            padding: 0;
            width: 100%;

            &:focus, 
            &:active {
                outline: 0;
            } 
            
            &::placeholder {
                color: ${PrestoAppTheme.colors.baseGrey};
            }

            &[type=number]::-webkit-inner-spin-button, 
            &[type=number]::-webkit-outer-spin-button { 
                -webkit-appearance: none; 
                margin: 0; 
            }
        } 
        
        &.is-password {
            & .text-input { 
                position: relative;

                & > input { 
                    &.masked-display {
                        position: relative;

                        /* NOTE: 
                        Hide BG and text, but show caret.
                        letter-spacing and font-family are used to evenly spaced the caret as user type.
                        Different letter-spacing value for different OS is not the best method, 
                            but I can't find a better method at the moment for password-styled input with numeric keyboard
                        */
                        background: transparent;
                        color:black; // sets the color of both caret and text
                        -webkit-text-fill-color: transparent;
                        letter-spacing: ${
                            getOSUserAgent() === OSType.ANDROID 
                                ? '-0.37' 
                                : (getOSUserAgent() === OSType.IOS ? '0.27' : '-0.37')
                            }em;
                        font-family: Courier New;

                        &::selection { 
                            background-color: #b3d7fe;  // default blue highlight 
                            color:black;                // sets the color of both caret and text
                            -webkit-text-fill-color: transparent;
                        }
                    }

                    &.password-display {
                        position: absolute;
                    }
                }
            }
        }
    }
    
    & > .boxedInput { 
        display: flex;
        font-size: ${PrestoAppTheme.layout.fontSizeStandard};

        &.disabled {
            border-bottom: 1px solid ${PrestoAppTheme.colors.baseSnow};
        }

        &.has-country-selector {
            position: relative;
        }

        & .pre-text, 
        & .text-input, 
        & .text-input > input { 
            height: 2.1rem;
            line-height: 2.1rem;
            font-weight: 300;
        }

        & .pre-text {
            width: 5.7rem;
            margin-right: ${PrestoAppTheme.layout.smallGap};

            & .country-code-selector {
                position: static;

                & [class^="react-custom-flag-select__select__selector"] {
                    padding: 0;

                    & [class^="react-custom-flag-select__select__dropdown-flag"] {
                        flex: 0 0 40%;
                    }

                    & [class^="react-custom-flag-select__select__dropdown-name"] {
                        flex: 0 0 55%;
                        justify-content: inherit;

                        & [class^="react-custom-flag-select__select__dropdown-icon"]:before {
                            width: 6px;
                            height: 6px;
                            top: 3px;
                            right: 3px;
                            border: 0;
                            border-right: 2px solid #999;
                            border-top: 2px solid #999;
                            transform: rotate(135deg);
                        }
                    }
                }

                & [class^="react-custom-flag-select__select__options-container"] {
                    width: 100%;
                    border: 1px solid ${PrestoAppTheme.colors.baseGrey};
                    box-shadow: 0 0 0;
                    box-sizing: border-box;
                    border-radius: ${PrestoAppTheme.layout.borderRadius};
                    font-size: ${PrestoAppTheme.layout.fontSizeSmall};
                    overflow: hidden;

                    & [class^="react-custom-flag-select__select__searchInputWrapper"] {
                        padding: 0;
                        border-bottom: 1px solid ${PrestoAppTheme.colors.baseGrey};
                        height: 2rem;

                        & [class^="react-custom-flag-select__select__searchInputSearchIcon"] {
                            display: none;
                        }

                        & [class^="react-custom-flag-select__select__searchInput"] {
                            height: 100%;
                            border: 0;
                            padding: 0 ${PrestoAppTheme.layout.smallGap};

                            &:focus {
                                outline: none;
                            }
                        } 
                    }

                    & [class^="react-custom-flag-select__select__options-item"] {
                        display: flex;
                        justify-content: space-between;
                        line-height: 1.2rem;
                        padding: ${PrestoAppTheme.layout.xSmallGap} ${PrestoAppTheme.layout.commonGap};

                        & [class^="react-custom-flag-select__select__dropdown-flag"] {
                            flex: inherit;
                            width: 1.5rem;
                        }
                        
                        & [class^="react-custom-flag-select__select__dropdown-name"] {
                            flex: inherit;
                            width: calc(100% - 1.5rem - ${PrestoAppTheme.layout.smallGap});
                            text-align: left;
                            justify-content: normal;
                        }
                    }

                    & [class*="react-custom-flag-select__select__hover-active"] {
                        background-color: #e1e1e1;
                        color: #4a4a4a;
                    }
                }
            }
        }

        & .text-input { 
            width: 100%;
        }
        
        & .text-input > input { 
            border: 0;
            padding: 0;
            width: 100%;
            
            background-color: ${PrestoAppTheme.colors.baseSnow};
            border-radius: 4px;
            padding: 6px 20px;
            box-sizing: border-box;

            &:focus, 
            &:active {
                outline: 0;
            } 
            
            &::placeholder {
                color: ${PrestoAppTheme.colors.baseGrey};
            }

            &[type=number]::-webkit-inner-spin-button, 
            &[type=number]::-webkit-outer-spin-button { 
                -webkit-appearance: none; 
                margin: 0; 
            }
        } 
        
        &.is-password {
            & .text-input { 
                position: relative;

                & > input { 
                    &.masked-display {
                        position: relative;

                        /* NOTE: 
                        Hide BG and text, but show caret.
                        letter-spacing and font-family are used to evenly spaced the caret as user type.
                        Different letter-spacing value for different OS is not the best method, 
                            but I can't find a better method at the moment for password-styled input with numeric keyboard
                        */
                        background: transparent;
                        color:black; // sets the color of both caret and text
                        -webkit-text-fill-color: transparent;
                        letter-spacing: ${
                            getOSUserAgent() === OSType.ANDROID 
                                ? '-0.37' 
                                : (getOSUserAgent() === OSType.IOS ? '0.27' : '-0.37')
                            }em;
                        font-family: Courier New;

                        &::selection { 
                            background-color: #b3d7fe;  // default blue highlight 
                            color:black;                // sets the color of both caret and text
                            -webkit-text-fill-color: transparent;
                        }
                    }

                    &.password-display {
                        position: absolute;
                    }
                }
            }
        }
    }    
`;
